import { useDispatch } from "react-redux";

import { StarOutlined, StarOutlineOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { yellow } from "@mui/material/colors";

import { setProjectFavorite, setProjectPackFavorite } from "slices/projects";

export const CustomFavoriteCell = ({ rowObj }) => {
	const dispatch = useDispatch();

	const setFavorite = () => {
		if (rowObj.model_name === "UserProjectPacks") {
			if (rowObj.is_favorite === true) {
				dispatch(setProjectPackFavorite({ projectPackId: rowObj.id, action: "del" }));
			} else {
				dispatch(setProjectPackFavorite({ projectPackId: rowObj.id, action: "add" }));
			}
		} else if (rowObj.model_name === "UserProjects") {
			if (rowObj.is_favorite === true) {
				dispatch(setProjectFavorite({ projectId: rowObj.id, action: "del" }));
			} else {
				dispatch(setProjectFavorite({ projectId: rowObj.id, action: "add" }));
			}
		}
	};

	return (
		<td
			key={`cell-favorite-${rowObj.id}`}
			className="TableCell"
			clm="favorite"
			treecell="false"
			title={rowObj.is_favorite === true ? "Удалить из избранного" : "Добавить в избранное"}
		>
			<IconButton
				size="small"
				onClick={(e) => {
					e.stopPropagation();
					setFavorite((prev) => !prev);
				}}
				sx={{
					padding: "4px",
					opacity: rowObj.is_favorite === true ? 1 : 0,
					transition: "opacity 300ms",
				}}
			>
				{rowObj.is_favorite ? (
					<StarOutlined
						sx={{
							fontSize: "20px",
							color: yellow[600],
						}}
					/>
				) : (
					<StarOutlineOutlined
						sx={{
							fontSize: "20px",
							color: yellow[600],
						}}
					/>
				)}
			</IconButton>
		</td>
	);
};
